var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('span',[_c('b',[_vm._v(_vm._s(_vm.email))])]),_c('app-button',{staticClass:"ml-4",attrs:{"icon":""},on:{"click":_vm.onLogout}},[_c('app-icon',{attrs:{"name":"logout"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }